import { useEffect } from "react";
import { TextField, MenuItem } from "@mui/material";
import useProductPresentations from "../hooks/useProductPresentations";

const PresentationSelector = ({ value, onChange, hiddenLabel = false }) => {
  const { presentations } = useProductPresentations();

  useEffect(() => {
    if (!presentations.length || !value) return;

    const exists = presentations.some((p) => p.name === value);
    if (!exists) onChange("");
  }, [value, presentations, onChange]);

  return (
    <TextField
      select
      size="small"
      label={hiddenLabel ? "" : "Presentation"}
      fullWidth
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={!presentations.length}
    >
      <MenuItem value="">
        —
      </MenuItem>
      {presentations.map((p) => (
        <MenuItem key={p.id} value={p.name}>
          {p.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default PresentationSelector;